export default {
  no_results: {
    title: 'Keine Ergebnisse für "{{search}}"',
    desc: 'Entschuldigung, wir konnten keinen Treffer finden. Bitte versuche es mit einem anderen Suchbegriff.',
  },
  empty_menu: {
    title: 'Noch keine Artikel verfügbar',
    desc: 'Dieses Menü hat momentan nichts anzuzeigen. Schau bald wieder vorbei.',
  },
};
